import { SVG_TYPE, USER_ROLE, ROUTE_ENUM } from "enums";
import "./dashboard-top-bar.scss";
import { useLogout } from "hooks/auth/";
import { ContextMenu, SVG } from "components";
import { useState } from "react";
import { ChangePassword } from "features/users";

import { useNavigate } from "react-router";

interface DashboardTopBarType {
  user: any;
}

const DashboardTopBar = ({ user }: DashboardTopBarType) => {
  const { mutate: logout } = useLogout({});

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isAdmin = user?.role === USER_ROLE.admin;
  const isFitterOrMeasurer =
    user?.role === USER_ROLE.fitter || user?.role === USER_ROLE.measurer;

  const adminSubmenuItems = () => {
    return [
      {
        name: "Zmień hasło",
        action: () => {
          setIsModalOpen(true);
        },
      },

      {
        name: "Wyloguj się",
        action: async () => {
          await logout();
        },
      },
    ];
  };

  const handleSynchroRedirect = () => {
    navigate(ROUTE_ENUM.SYNCHRO_OFFLINE);
  };



  return (
    <>
      <ChangePassword
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <div className="dtb__wrapper">
        <div className="dtb">
          <SVG className="dtb__logo" type={SVG_TYPE.LOGO} />

          {isFitterOrMeasurer && (
            <div className="dtb__sync">
              <div onClick={() => handleSynchroRedirect()}>
                <SVG type={SVG_TYPE.GLOBE} />
              </div>

            </div>
          )}

          {isAdmin ? (
            <div className="dtb__user">
              <div className="dtb__user-label">
                <ContextMenu
                  className="dtb__user-submenu"
                  items={adminSubmenuItems()}
                >
                  {user.firstName} {user.lastName}{" "}
                  <SVG type={SVG_TYPE.CHEVRON_DOWN} />
                </ContextMenu>
              </div>
            </div>
          ) : (
            <div
              onClick={async () => await logout()}
              className="dtb__logout-wrapper"
            >
              <SVG type={SVG_TYPE.LOGOUT} />
              <span>Wyloguj się</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardTopBar;
